import LOGIN from "../symbols/login";

type State = {
  loading: boolean;
  error: any;
  isUserAdmin: boolean | null | undefined;
  isCollectEnabled: boolean | null | undefined;
  isCollectOnly: boolean | null | undefined;
  userLoggedIn: boolean;
  role: string;
  shopName: string;
  merchantLogo: string;
  termsAccepted: boolean;
};

const initialState: State = {
  loading: false,
  error: false,
  isUserAdmin: null,
  isCollectEnabled: null,
  isCollectOnly: null,
  userLoggedIn: false,
  role: "",
  shopName: "",
  merchantLogo: "",
  termsAccepted: false,
};

function LoginReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOGIN.LOGIN:
      return { ...state, loading: true, error: false };
    case LOGIN.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userLoggedIn: true,
        isUserAdmin: action.payload.isUserAdmin,
        isCollectEnabled:
          action.payload.data.isCollectEnabled ||
          action.payload.data.Result?.IsCollectEnabled,
        isCollectOnly:
          action.payload.data.isCollectOnly ||
          action.payload.data.Result?.IsCollectOnly,
        role: action.payload.data.role || action.payload.data.Result?.Role,
        shopName:
          action.payload.data.shopName || action.payload.data.Result?.ShopName,
        merchantLogo:
          action.payload.data.merchantLogoUrl ||
          action.payload.data.Result?.MerchantLogoUrl,
        termsAccepted:
          action.payload.data.termsAccepted ||
          action.payload.data.Result?.TermsAccepted,
      };
    case LOGIN.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        userLoggedIn: false,
        isUserAdmin: null,
      };
    case LOGIN.CLEAR_LOGIN:
      return {
        ...state,
        loading: false,
        error: false,
        userLoggedIn: false,
        isUserAdmin: null,
        isCollectEnabled: null,
        isCollectOnly: null,
        shopName: "",
        role: "",
        merchantLogo: "",
        termsAccepted: false,
      };
    case LOGIN.PROFILE_SUCCESS:
      return {
        ...state,
        isCollectEnabled: action.payload.data.Result.IsCollectEnabled,
        isCollectOnly: action.payload.data.Result.IsCollectOnly,
        termsAccepted: action.payload.data.Result.TermsAccepted,
      };

    default:
      return state;
  }
}
export default LoginReducer;
